export class UpdateSnapshotRecipeResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recipe",
            "baseName": "recipe",
            "type": "SnapshotRecipe",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateSnapshotRecipeResponse.attributeTypeMap;
    }
    constructor() {
    }
}
